import { HttpService } from "@/core/services/http.service";
export class reconnoiterBtnService {
  static useDeleteApi() {
    const api = (ids) =>
      HttpService.axios({
        method: "POST",
        url: `/prospect_record/deleteBatch`,
        data:{ids},
      });
    return HttpService.useRequest<void>(api);
  }
}